import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './assets/order-create-screen.module.scss';
import Loader from 'src/components/Loader';
import RoleLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/OrderMultiForm';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import OrderEnum from 'src/enumerables/order-enum';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import { IServiceType } from 'src/types/service-types';
import { routes } from '../../../../../../navigation';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import Router from '../../../../../../navigation/router';
import { OrderFormData } from '../../components/OrderMultiForm';
import { asyncPersistOrder, getCheckOrders, resetDouble } from '../../../../../../store/actions/order-actions';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { changeToZeroMomentDate } from '../../../../../../helpers/timeHelpers';
import { SubmissionError } from 'redux-form';

export interface StateProps {
    orderTypeValue: string | number;
    serviceTypeProviderValue: string | number;
    valueType: SelectObject;
    statusItemValue: string | number;
    orderTypes: SelectObject[];
    serviceTypeProviders: SelectObject[];
    formData: OrderFormData;
    inProgress: boolean;
    students: SelectObject[];
    serviceTypesOrder: Paginated<IServiceType>;
    ordersData: any;
    dataFormOrders: any;
    isDouble: any;
}

export interface DispatchProps {
    getStudentsAct: (params: QueryParams) => void;
    getOrderServiceTypes: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const OrderCreateScreen: React.FunctionComponent<Props> = (props) => {
    const [files, setFiles] = useState([]);
    const [orderDoc, setOrderDoc] = useState(null);
    const [dataSaveModal, setSaveModal] = useState(false);
    const [isUniqueName, setIsUniqueName] = useState(false);
    const [isCheckName, setIsCheckName] = useState(false);
    const [isAllNameChecked, setIsAllNameChecked] = useState(0);
    const [requestProceed, setRequestProceed] = useState(0);
    const [isDuplicate, setIsDuplicate] = useState(false);

    useEffect(() => {
        props.getStudentsAct({
            page: 1,
            itemsPerPage: 9000,
        });

        props.getOrderServiceTypes({
            page: 1,
            itemsPerPage: 9000,
        });
        // eslint-disable-next-line
    }, [props.getStudentsAct, props.getOrderServiceTypes]);

    useEffect(() => {
        setSaveModal(props.isDouble == 'no' ? false : props.isDouble);
    }, [props.isDouble]);

    /*useEffect(() => {
        if (isCheckName) {
            const req = requestProceed + 1;
            setRequestProceed(req);
             console.log('props ', props);
            if (props.ordersData.totalCount && !props.ordersData.inProgress) {
                setSaveModal(true);
            } else if (requestProceed == isAllNameChecked) {
                setIsUniqueName(true);
            }
        }
    }, [props.ordersData.inProgress]);*/

    const dispatch = useDispatch();
    const handleCheck = (event: any) => {
        console.log(props.dataFormOrders);

        if (!props.dataFormOrders?.orders || !props.dataFormOrders?.orders?.length) {
            toast.error('At least one service form must be filled in');

            return false;
        }

        let counter = 0;
        const names: string[] = [];

        props.dataFormOrders.orders.forEach(async (order: any, ind: number) => {
            const dateFrom = new Date(order.caseNumberValidityFrom).getTime();
            const dateTo = new Date(order.caseNumberValidityTo).getTime();

            if (!isNaN(dateFrom) && !isNaN(dateTo) && dateFrom < dateTo) {
                let name: any = [];

                const student_caseNumber: any = [];
                const caseDate: any = [];
                if (props.dataFormOrders.studentDropDown) {
                    student_caseNumber.push(props.dataFormOrders.studentDropDown.label);
                }
                if (props.dataFormOrders.caseNumber) {
                    student_caseNumber.push(props.dataFormOrders.caseNumber);
                }
                if (student_caseNumber.length) {
                    name.push(student_caseNumber.join('_'));
                }

                if (order.serviceTypeProviderDropDown?.value) {
                    name.push(order.serviceTypeProviderDropDown.label);
                }
                if (order.serviceTypeDropDown?.value) {
                    name.push(order.serviceTypeDropDown.label);
                }
                if (order.caseNumberValidityFrom) {
                    caseDate.push(changeToZeroMomentDate(order.caseNumberValidityFrom));
                }

                if (order.caseNumberValidityTo) {
                    caseDate.push(changeToZeroMomentDate(order.caseNumberValidityTo));
                }
                if (caseDate.length) {
                    name.push(caseDate.join('_'));
                }

                if (order.location) {
                    name.push(order.location);
                }

                name = name.join('/');
                order.name = name;

                names.push(name);
                setIsCheckName(true);
                counter = counter + 1;
            } else {
                //toast.error('Incorrect date!');
                throw new SubmissionError({
                    caseNumberValidityTo: 'Incorrect date!',
                    caseNumberValidityFrom: 'Incorrect date!',
                    _error: 'Incorrect date!',
                });
            }
        });
        dispatch(
            getCheckOrders({
                page: 1,
                filters: {
                    names: names,
                },
                itemsPerPage: 80,
            }),
        );

        setIsAllNameChecked(counter);
    };

    /*  const handleSub = (handleSubmit: (e: any) => void, e: any) => {

        if (!orderDoc) {
            toast.error('Need Order Doc!');
            return false;
        } else {
            handleSubmit(e);

        }
    };*/

    const typeEnumSubT = OrderEnum ? OrderEnum.getEnum('OrderSubtype') : {};
    const valuesOrderSubtype: SelectObject[] = getValFromEnum(typeEnumSubT);

    const AuthorizationSources = OrderEnum ? OrderEnum.getEnum('AuthorizationSource') : {};
    const valuesAuthorizationSources: SelectObject[] = getValFromEnum(AuthorizationSources);

    const OrderStatusValues = OrderEnum ? OrderEnum.getEnum('OrderStatus') : {};
    const valuesOrderStatus: SelectObject[] = getValFromEnum(OrderStatusValues);

    const typeEnum = OrderEnum ? OrderEnum.getEnum('OrderCaseType') : {};
    const orderCaseTypeValues: SelectObject[] = getValFromEnum(typeEnum);

    const referralEnum = OrderEnum ? OrderEnum.getEnum('ReferralSource') : {};
    const orderReferralSourceValues: SelectObject[] = getValFromEnum(referralEnum);

    const serviceTypesOrderValues: SelectObject[] = [];
    props.serviceTypesOrder.list.forEach((it: Partial<IServiceType>) => {
        const labelArr = [];
        if (it.title) {
            labelArr.push(it.title);
        }
        if (it.cpt) {
            labelArr.push(`CPT: [${it.cpt}]`);
        }
        const label = labelArr.join(', ');
        serviceTypesOrderValues.push({ value: it.id, label });
    });

    return (
        <RoleLayout>
            <Breadcrumbs
                noGenerate={true}
                items={[
                    { name: 'ORDERS', path: Router.generate(routes.ORDERS_LIST, { status: '' }) },
                    { name: `ADD NEW`, path: '' },
                ]}
            />
            <div className={classNames(styles.wrapForm)}>
                {props.inProgress ? <Loader /> : null}
                <Form
                    orderDoc={orderDoc}
                    setOrderDoc={setOrderDoc}
                    removeOrderDoc={(id) => {
                        setOrderDoc(null);
                    }}
                    orderTypeValue={props.orderTypeValue}
                    valueType={props.valueType}
                    statusItemValue={props.statusItemValue}
                    OrderTypes={props.orderTypes}
                    ServiceTypeProviders={props.serviceTypeProviders}
                    serviceTypeProviderValue={props.serviceTypeProviderValue}
                    formData={props.formData}
                    valuesOrderSubtype={valuesOrderSubtype}
                    valuesOrderStatus={valuesOrderStatus}
                    orderReferralSourceValues={orderReferralSourceValues}
                    AuthorizationSources={valuesAuthorizationSources}
                    orderCaseTypeValues={orderCaseTypeValues}
                    studentsValues={props.students}
                    serviceTypesOrderValues={serviceTypesOrderValues}
                    files={files}
                    setFiles={setFiles}
                    dataSaveModal={dataSaveModal}
                    setSaveModal={setSaveModal}
                    removeFile={(id) => {
                        files.splice(id, 1);
                        setFiles([...files]);
                    }}
                    handleCheck={handleCheck}
                    isUniqueName={isUniqueName}
                    isDouble={props.isDouble}
                    resetDouble={() =>
                        dispatch(resetDouble())
                    }
                    initialValues={{
                        orderTypeDropDown: props.orderTypes[0],
                        orderSubtypeDropDown: valuesOrderSubtype[0],
                        authorizationSourceDropDown: valuesAuthorizationSources[0],

                        //    ...initVal,
                    }}
                />
            </div>
        </RoleLayout>
    );
};

export default OrderCreateScreen;
